import styled from 'styled-components'

type Props = {
  userImage?: string
}

const ComponentStyled = styled.div<Props>`
  .social-logged-box {
    max-width: 600px;
    margin: 0 auto;

    .social-logged-content {
      padding: 50px;
      background-color: ${({ theme }) => theme.colors.secondaries.opacity10};
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;

      .btns-wrapper {
        flex-wrap: wrap-reverse;
      }

      .logged-title {
        font-family: 'Cabin';
        font-weight: 700;
        font-size: 24px;
        line-height: 24px;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.colors.black};
        margin-bottom: 50px;
        text-align: center;
      }

      .avatar {
        position: relative;
        width: 96px;
        height: 96px;
        margin-bottom: 25px;
        border-radius: 96px;
        margin: 0 auto 25px auto;
        background-image: ${({ userImage }) => `url("${userImage}")`};
        background-position: center;
        background-size: cover;
      }

      .edit-logged span {
        cursor: pointer;
      }

      .other-info span {
        text-transform: capitalize;
      }

      .info-desc,
      .edit-logged,
      .other-info {
        text-align: center;
        font-family: 'Cabin';
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0.02em;
        margin-bottom: 20px;
      }

      .info-desc {
        color: ${({ theme }) => theme.colors.black};
      }

      .edit-logged {
        color: ${({ theme }) => theme.colors.blue2};
      }

      .other-info {
        color: ${({ theme }) => theme.colors.gray4};
        margin-bottom: 100px;
      }

      .privacy {
        text-align: center;
        font-family: 'Cabin';
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: -0.02em;
        color: ${({ theme }) => theme.colors.gray3};
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .social-logged-box {
      .social-logged-content {
        padding: 50px 15px;

        .logged-title {
          font-size: 16px;
          line-height: 18px;
        }

        .other-info {
          margin-bottom: 100px;
        }
      }
    }
  }
`

export default ComponentStyled
